import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ReactModal from 'react-modal'
import { Motion, spring } from 'react-motion'
import { connect } from 'react-redux'
import ReactGA from 'react-ga4'
import { modal, nestedModal } from 'redux/modules/app'

function decorator(config = {}) {
  return ComposedComponent => {
    @connect(
      state => ({
        modalObj: state.app.modal,
      }),
      { modal, nestedModal }
    )
    class ModalDec extends Component {
      static propTypes = {
        modalObj: PropTypes.object,
        contentLabel: PropTypes.string,
        id: PropTypes.string.isRequired,
        nestedModal: PropTypes.func,
        onSubmit: PropTypes.func,
        onClose: PropTypes.func,
        modal: PropTypes.func.isRequired,
        noEscape: PropTypes.bool,
      }

      static defaultProps = {
        contentLabel: '',
      }

      state = {
        y: -30,
        opacity: 0,
        z: -2000,
        shouldClose: false,
      }

      componentWillReceiveProps(nextProps) {
        if (this.props.modalObj.id !== nextProps.modalObj.id && !nextProps.modalObj.id) {
          this.handleOnRequestClose()
        }

        if (this.props.id !== this.props.modalObj.id && nextProps.id === nextProps.modalObj.id) {
          ReactGA.send(this.props.id)
        }
      }

      componentWillUnmount() {
        this.handleClose()
      }

      handleOnRequestClose = e => {
        if (this.props.noEscape === true && (e && e.type && e.type === 'keydown' && e.keyCode === 27)) {
          return
        }

        this.setState(
          {
            y: -30,
            opacity: 0,
            z: -2000,
            shouldClose: true,
          },
          () => {
            this.handleClose()
          }
        )
      }

      handleClose = () => {
        if (this.props.onClose) {
          this.props.onClose()
        }
        this.closeModal()
      }

      handleAfterOpen = () => {
        this.setState({
          y: 0,
          opacity: 1,
          z: 0,
          shouldClose: false,
        })
      }

      handleAfterSubmit = () => {
        if (this.props.onSubmit) {
          this.props.onSubmit()
        }
        this.closeModal()
      }

      closeModal = () => {
        const { modalObj, id } = this.props

        if (modalObj.nestedId === id) {
          this.props.nestedModal(null)
        } else {
          const { id, next, data } = modalObj

          // If it's already null, dont fire another action
          if (![id, next, data].every(item => item === null)) {
            this.props.modal(null, null, null)
          }
        }
      }

      render() {
        const { modalObj, id } = this.props

        const { y, z, opacity } = this.state

        const isNestedOpen = modalObj.nestedId === id
        const isOpen = modalObj.id === id

        if (!isNestedOpen && !isOpen) {
          return null
        }

        return (
          <ReactModal
            isOpen={isNestedOpen || isOpen}
            onRequestClose={this.handleOnRequestClose}
            style={{
              ...config.resetStyles,
              overlay: {
                ...config.resetStyles.overlay,
                zIndex: isNestedOpen ? '31' : '20',
              },
            }}
            className="modal-content"
            onAfterOpen={this.handleAfterOpen}
            closeTimeoutMS={380}
            shouldCloseOnOverlayClick={false}
            contentLabel={this.props.contentLabel}
          >
            <Motion
              defaultStyle={{ y, z, opacity }}
              style={{
                y: spring(y, { stiffness: 65, damping: 13 }),
                opacity: spring(opacity, { stiffness: 65, damping: 13 }),
                z: spring(z),
              }}
            >
              {interpolatingStyle => (
                <div
                  style={{
                    transform: `translate3d(0, ${interpolatingStyle.y}px, 0)`,
                    opacity: `${interpolatingStyle.opacity}`,
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    right: 0,
                    zIndex: '1000',
                    transformOrigin: '50% 50%',
                    perspective: '500px',
                  }}
                >
                  <ComposedComponent
                    {...this.props}
                    onAfterSubmit={this.handleAfterSubmit}
                    onClose={this.handleClose}
                  />
                </div>
              )}
            </Motion>
          </ReactModal>
        )
      }
    }
    return ModalDec
  }
}

export default decorator
